import { makePersisted } from '@solid-primitives/storage'
import { createContext, createSignal, type JSX, useContext } from 'solid-js'

type PinnedContextType = {
  pinned: () => boolean
  setPinned: (value: boolean) => void
  toogglePinned: () => void
}

const PinnedContext = createContext<PinnedContextType>()

export const PinnedProvider = (props: { children: JSX.Element }) => {
  const [pinned, setPinned] = makePersisted(createSignal(true), {
    name: `${__APP_HASH__}-pinned`,
    storage: localStorage
  })
  const toogglePinned = () => setPinned(prev => !prev)
  return <PinnedContext.Provider value={{ pinned, setPinned, toogglePinned }}>{props.children}</PinnedContext.Provider>
}

export const usePinned = () => {
  const context = useContext(PinnedContext)
  if (!context) throw new Error('usePinned must be used within a PinnedProvider')
  return context
}
